<template>
  <div class="wrapper">
    <div class="section">
      <div class="main">
        <div class="contact-content">
          <div class="container">
            <div class="row">
              <div class="col-md-5 ml-auto mr-auto">
                <h2 class="title">Quiero Afiliarme</h2>
                <p class="description">
                  Dejanos tus datos, y un asesor se estará comunicando con vos en la brevedad.
                  <br />
                  <br />
                </p>
                <form role="form" id="contact-form" method="post">
                  <label>Nombre y Apellido</label>
                  <fg-input
                    v-validate="'required'"
                    name="nombre"
                    placeholder="Su nombre..."
                    v-model="form.nombre"
                    addon-left-icon="now-ui-icons users_circle-08"
                  ></fg-input>
                  <span
                    v-show="errors.has('nombre')"
                    class="error-message"
                  >{{ errors.first('nombre') }}</span>

                  <label>Email</label>
                  <fg-input
                    v-validate="'required|email'"
                    name="email"
                    placeholder="Email..."
                    v-model="form.email"
                    addon-left-icon="now-ui-icons ui-1_email-85"
                  ></fg-input>
                  <span
                    v-show="errors.has('email')"
                    class="error-message"
                  >{{ errors.first('email') }}</span>

                  <label>Teléfono</label>

                  <fg-input
                    v-validate="'required'"
                    name="telefono"
                    placeholder="Número aquí..."
                    v-model="form.telefono"
                    addon-left-icon="now-ui-icons tech_mobile"
                  ></fg-input>
                  <span
                    v-show="errors.has('telefono')"
                    class="error-message"
                  >{{ errors.first('telefono') }}</span>

                  <div class="form-group">
                    <label>Condicion</label>
                    <fg-input class>
                      <el-select
                        class="select-default"
                        v-model="form.condicionId"
                        ref="condicionAfiliacionSelect"
                      >
                        <el-option
                          v-for="item in condicionAfiliacionList"
                          :value="item.Value"
                          :label="item.Text"
                          :key="item.Value"
                        ></el-option>
                      </el-select>
                    </fg-input>
                  </div>

                  <div class="form-group">
                    <label>Su mensaje</label>
                    <textarea
                      class="form-control"
                      id="message"
                      rows="6"
                      v-validate="'required'"
                      v-model="form.mensaje"
                      name="mensaje"
                    ></textarea>
                    <span
                      v-show="errors.has('mensaje')"
                      class="error-message"
                    >{{ errors.first('mensaje') }}</span>
                  </div>
                  <div class="form-group">
                    <vue-recaptcha :sitekey="captchaKey" @verify="onVerify" v-show="!verified"></vue-recaptcha>
                  </div>
                  <div class="submit text-center">
                    <input
                      v-show="verified"
                      type="button"
                      @click="sendForm"
                      class="btn btn-primary"
                      round
                      value="Enviar"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, InfoSection, FormGroupInput } from "@/components";
import { API_KEY } from "@/constants";
import Vue from "vue";
import { Select, Option } from "element-ui";
import * as miscService from "../../services/MiscService";
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "home",
  bodyClass: "home",
  components: {
    "vue-recaptcha": VueRecaptcha,
    InfoSection,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      verified: false,
      captchaKey: process.env.VUE_APP_CAPTCHA_KEY,
      condicionAfiliacionList: [],
      form: {
        condicionId: 1,
        nombre: "",
        email: "",
        telefono: "",
        empresa: "",
        mensaje: ""
      }
    };
  },
  async mounted() {
    this.form.condicionId = 1;
    this.condicionAfiliacionList = await miscService.getAllCondicionAfiliacion();
  },
  methods: {
    async sendForm() {
      var self = this;
      this.errors = [];
      this.$validator.validateAll().then(async isValid => {
        if (!isValid) {
          self.$noty.error("Corrija los errores antes de continuar.");
        } else {
          await self.enviar();
        }
      });
    },
    async enviar() {
      var selectedLabel = this.$refs.condicionAfiliacionSelect.selectedLabel;
      this.form.condicionTexto = selectedLabel;
      this.form.tipoFormulario = "Quiero Afiliarme";
      let self = this;
      var result = await this.$zaiq()
        .post("contacto/create", this.form)
        .then(success => {
          self.cleanForm();
          self.$noty.success("Se ha enviado correctamente el mensaje.");
        })
        .catch(error => {
          debugger;
          self.$noty.error(
            "Ha ocurrido un error intentando enviar el mensaje."
          );
        });
    },
    cleanForm() {
      this.form = {
        condicionId: 1,
        nombre: "",
        email: "",
        telefono: "",
        empresa: "",
        mensaje: ""
      };
      this.$validator.reset();
    },
    onVerify: function(response) {
      this.verified = true;
    }
  }
};
</script>
<style scoped>
.form-group >>> .el-input__inner[readonly] {
  background-color: #888888 !important;
}

.error-message {
  display: block;
  font-size: 0.75em;
  margin-bottom: 0.5em;
  color: #f22435;
}
</style>

</style>
